import React,{memo} from "react";
function Notfound(){
    return(
        <>
        <div className="text-indigo-700 text-3xl grow flex justify-center items-center">Product Not Found</div>
        </>
    )
}
export default memo(Notfound);